// extracted by mini-css-extract-plugin
export default {"iconContainer":"Benchmark_iconContainer__DsO0F","positive":"Benchmark_positive__661ii","negative":"Benchmark_negative__L9elP"};